module.exports = __webpack_public_path__ + "img/consultation_part3.583ff25d.png";